import NotLoginFileRequestModal from "@/components/Modal/NotLoginFileRequestModal";
import { Box, Button, VStack } from "@chakra-ui/react";
import { useOverlay } from "@toss/use-overlay";
import {
  colors,
  customEvent,
  getCdnImageSrc,
  HLine,
  Image,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  Spacing,
} from "goi_common";
import { markMatchRequestOnboardingEligible } from "@/utils/matchRequestOnboardingExperiment";
import { useRouter } from "next/router";

const MajorServiceSection = () => {
  const overlay = useOverlay();
  const router = useRouter();
  const handleChecklistClick = () => {
    customEvent({ newGtm: { path: "home", trigger_and_target: "step_guide_fixed_button" } });

    overlay.open(({ isOpen, close: onClose }) => {
      return <NotLoginFileRequestModal path="home" isOpen={isOpen} onClose={onClose} />;
    });
  };
  const handleEstimateClick = () => {
    customEvent({
      newGtm: {
        path: "home",
        trigger_and_target: "shrtcut_btn_mtch_rqst-uv_mtch_rqst",
      },
    });
    markMatchRequestOnboardingEligible();
    router.push("/match/request/");
  };
  const handleServiceClick = () => {
    customEvent({
      newGtm: {
        path: "home",
        trigger_and_target: "shrtcut_btn_service-uv_service",
      },
    });

    router.push("/service/");
  };
  return (
    <VStack spacing={0}>
      <HLine height="16px" color={colors.gray50} />
      <Box padding="56px 20px 60px">
        <VStack width="100%" padding="20px" background="#ffedcc" borderRadius="12px">
          <Box width="100%" textAlign="start">
            <Box
              width="-webkit-fit-content"
              borderRadius="20px"
              background={colors.orange650}
              padding="3px 10px"
              className="body_14_m white"
            >
              NEW
            </Box>
          </Box>
          <Image
            style={{
              marginTop: "-12px",
            }}
            src={getCdnImageSrc("platform/home/prime.png")}
            height="166px"
          />
          <Spacing gap={16} />
          <VStack width="100%" alignItems="center" spacing="12px">
            <Box className="subtitle_21_sb gray900" textAlign="center" width="100%">
              월 100원으로
              <br />
              평생 장례 비용 보장
            </Box>
            <Box className="body_16_r gray700" textAlign="center" width="100%">
              납입금 부담없는 가격 보장형 후불제 상조
            </Box>
            <Button
              width="100%"
              background="white"
              padding="10px"
              height="44px"
              borderRadius="6px"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "home",
                    trigger_and_target: "shrtcut_btn_prime-uv_prime",
                  },
                });
                router.push("https://prime.goifuneral.co.kr/?utm_campaign=home_platform");
              }}
            >
              <span className="body_16_m gray900">100원 상조 알아보기</span>
            </Button>
          </VStack>
        </VStack>
      </Box>
      <VStack width="100%" spacing="40px">
        <ServiceCard
          title="임종 준비 체크리스트 받아보기"
          description={`가까운 분의 임종을 앞두고 있을 때\n확인해야 할 내용들과 예상 견적표를 보내드려요`}
          backgroundColor="#78bfff"
          imageHeight="164px"
          imageName="checklist_3"
          buttonText="체크리스트 신청하기"
          onClick={handleChecklistClick}
        />
        <ServiceCard
          title="장례 예상 견적 계산하기"
          description={`장례 견적 미리 확인해 보고\n내 상황에 따른 상품 추천도 받아보세요`}
          backgroundColor="#3a5b4b"
          buttonText="자세히 알아보기"
          imageHeight="164px"
          imageName="services_3"
          onClick={handleEstimateClick}
        />
        <ServiceCard
          title="고이 상품 안내"
          description={`조문객 없이 장례 진행하는 무빈소장부터\n200명이 넘는 조문객도 문제없는 일반장까지`}
          backgroundColor={colors.warmGray500}
          buttonText="자세히 알아보기"
          imageHeight="164px"
          imageName="product_3"
          onClick={handleServiceClick}
        />
      </VStack>
    </VStack>
  );
};

const ServiceCard = ({
  title,
  description,
  backgroundColor,
  buttonText,
  imageName,
  imageHeight,
  onClick,
}: {
  title: string;
  description: string;
  backgroundColor: string;
  buttonText: string;
  imageHeight: string;
  imageName: string;
  onClick: () => void;
}) => {
  return (
    <VStack padding="20px" spacing="20px" width="100%">
      <VStack spacing="8px" width="100%" alignItems="start">
        <Box className="subtitle_21_sb gray900">{title}</Box>
        <Box className="body_16_r gray700" whiteSpace="pre-line">
          {description}
        </Box>
      </VStack>
      <VStack
        width="100%"
        padding="24px 24px 20px"
        borderRadius="12px"
        background={backgroundColor}
        alignItems="center"
        justifyContent="center"
        spacing="8px"
      >
        <Box width="100%" textAlign="center" alignItems="center">
          <Image
            style={{
              margin: "auto",
              maxHeight: imageHeight,
            }}
            src={getCdnImageSrc(`platform/home/${imageName}.png`)}
          />
        </Box>
        <LargeButton
          onClick={onClick}
          height={40}
          buttonType={LARGEL_BUTTON_TYPE.WHITE}
          className="body_14_m gray900"
        >
          {buttonText}
        </LargeButton>
      </VStack>
    </VStack>
  );
};

export default MajorServiceSection;
